module.exports = "/_next/static/images/section-for-fulfillment-mob-5025be15012c6f7782e5014c191e477e.png.webp";